import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, getManualResourceIdControl } from './shared-control-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { azureResourceSelectMethodOptions } from '../consts/metadata-consts';
import { azureMySQLDomain } from '../linked-service/azure-mysql-metadata';

const azureMySQLResourceId = `/subscriptions/<subscriptionID>/resourceGroups/<resourceGroupName>/providers/Microsoft.DBforMySQL/(servers|flexibleServers)/<resourceName>`;
const azureMySQLResourceIdFormat = `\/?subscriptions\/.+\/resourceGroups\/.+\/providers\/Microsoft.DBforMySQL\/(servers|flexibleServers)\/.+`;
const azureMySQLResourceIdErrorMessage = format(stringResources.InvalidResourceId, azureMySQLResourceId);
const resourceTypes = ['Microsoft.DBforMySQL/servers', 'Microsoft.DBforMySQL/flexibleServers'];

export const azureMySQLPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: resourceTypes,
    connectionSuffix: {
        'Microsoft.DBforMySQL/flexibleServers': 'networking',
        'Microsoft.DBforMySQL/servers': 'privateEndpoints'
    },
    resourceIdValidator: azureMySQLResourceIdFormat,
    groupIdMetadata: {
        mysqlServer: {
            linkedServiceType: adfModelTypeMap.azureMySql.linkedServiceType,
            groupId: 'mysqlServer',
            iconClass: 'svg-i-100x100-azure_database_for_mysql',
            displayName: stringResources.AzureMySql_DisplayText,
            controls: {
                creationControls: [{
                    type: 'radio-switch',
                    nested: 1,
                    label: stringResources.AccountSelectionMethodLabel,
                    description: stringResources.AzureSql_SelectMethodDescription,
                    options: azureResourceSelectMethodOptions,
                    isLabelVertical: true,
                    defaultValue: '{privateLinkResourceId != null ? "manual" : "azure"}',
                    cases: [
                        {
                            caseValue: 'azure',
                            children: [
                                {
                                    type: 'azure-server-database-select',
                                    bind: {
                                        resourceID: 'privateLinkResourceId'
                                    },
                                    resourceTypes,
                                    serverDomain: azureMySQLDomain,
                                    isServerSelectOnly: true,
                                    resourceTypeLabels: {
                                        flexibleServers: stringResources.FlexibleServer,
                                        servers: stringResources.SingleServer
                                    },
                                    validators: {
                                        resourceID: [
                                            { type: 'required', errorMessage: '' }
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            caseValue: 'manual',
                            children: [
                                getManualResourceIdControl(
                                    format(stringResources.PrivateEndpointResourceIdPlaceholder, azureMySQLResourceId),
                                    azureMySQLResourceIdFormat,
                                    azureMySQLResourceIdErrorMessage)
                            ]
                        }
                    ]
                }],
                readonlyControls: getReadonlyControl(azureMySQLResourceIdFormat, azureMySQLResourceIdErrorMessage)
            }
        }
    }
};
